import PropTypes from 'prop-types';
import useScreenLoadingTracking from 'services/custom-hooks/useScreenLoadingTracking';

/**
 * Component to track screen loading performance.
 * Useful for Class Components where hooks cannot be used directly.
 */
const PerformanceTracker = ({ screenId, isLoading, metadata }) => {
  useScreenLoadingTracking(screenId, isLoading, metadata);
  return null;
};

PerformanceTracker.propTypes = {
  screenId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  metadata: PropTypes.shape({}),
};

PerformanceTracker.defaultProps = {
  isLoading: false,
  metadata: {},
};

export default PerformanceTracker;
